/**
 * "Coming soon" polling.
 *
 * A master playlist that does not exist yet (404, or 403 from S3 when the
 * caller has no list permission) is not an error — the encode simply has not
 * published it. The wrapper waits: one immediate check, then a FIXED interval.
 * No backoff on purpose — a viewer sitting on a "coming soon" screen wants the
 * video the moment it appears, and the request is a single tiny GET.
 */
/** Fixed re-check interval. */
export const DEFAULT_POLL_INTERVAL_MS = 30_000;
/**
 * Fixed-interval poller. Checks never overlap: the next one is scheduled after
 * the previous settles.
 */
export class Poller {
    options;
    intervalMs;
    timer = null;
    running = false;
    stopped = false;
    constructor(options) {
        this.options = options;
        this.intervalMs = options.intervalMs ?? DEFAULT_POLL_INTERVAL_MS;
    }
    start() {
        if (this.running || this.stopped)
            return;
        this.running = true;
        if (this.options.immediate === false) {
            this.schedule();
        }
        else {
            void this.tick();
        }
    }
    stop() {
        this.stopped = true;
        this.running = false;
        if (this.timer !== null) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
    schedule() {
        if (this.stopped)
            return;
        this.timer = setTimeout(() => {
            this.timer = null;
            void this.tick();
        }, this.intervalMs);
    }
    async tick() {
        if (this.stopped)
            return;
        try {
            const available = await this.options.check();
            if (this.stopped)
                return;
            if (available) {
                this.stop();
                this.options.onAvailable();
                return;
            }
        }
        catch (error) {
            if (this.stopped)
                return;
            this.stop();
            this.options.onError?.(error);
            return;
        }
        this.schedule();
    }
}
//# sourceMappingURL=poller.js.map